import {SuperObjectModel} from './super-object-model';
import {OverviewField} from './object-view';
import { OverviewFieldSimple } from './overview-field-simple';

import {RefData} from "./ref-data";


export class SearchObject extends SuperObjectModel {


  $$columns: Array<OverviewField[]>;
  $$dmsStatus: string;
  $$hasChildren: boolean;
  $$icon: string;
  $$imageUrl: string;
  $$name: string;
  $$noImageIcon: string;
  $$refData: RefData;
  $$used: boolean;

  authority_id: string;
  authority_id_value: string;
  children: SearchObject[];
  content: string[];
  filters: any;
  icon: string;
  id: string;
  is_leaf: boolean;
  level: number;
  overview: OverviewField[];
  overview_simple: OverviewFieldSimple[];
  package_placement: any;
  selected: boolean;
  source: string;
}

export class SearchObjectRow {
  columns: SearchObject[] = [];
}
